// ImagePicker.jsx
import "./ImagePicker.scss";

import React, { useRef, useState } from "react";

import AppButton from "../../../../../../commons/buttons/AppButton";
import { Dropdown } from "react-bootstrap";
import HallAppToast from "../../../../../../commons/HallAppToast";

// ✅ ajuste o caminho se necessário

export default function ImagePicker({ onPickImage }) {
  const uploadRef = useRef(null);
  const cameraRef = useRef(null);

  const [isReading, setIsReading] = useState(false);

  const readFile = async (file) => {
    if (!file || isReading) return;

    // validação leve (boa UX)
    const isImage = String(file.type || "").startsWith("image/");
    if (!isImage) {
      HallAppToast?.genericError?.("Selecione um arquivo de imagem.");
      return;
    }

    try {
      setIsReading(true);

      const src = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const img = await new Promise((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = src;
      });

      onPickImage?.({
        src,
        fileName: file.name,
        file,
        width: img.naturalWidth || 1200,
        height: img.naturalHeight || 900,
      });
    } catch (e) {
      HallAppToast?.genericError?.();
    } finally {
      setIsReading(false);
      // permite selecionar o mesmo arquivo novamente
      if (uploadRef.current) uploadRef.current.value = "";
      if (cameraRef.current) cameraRef.current.value = "";
    }
  };

  return (
    <div className="tricho-imgpicker">
      {/* Upload */}
      <input
        ref={uploadRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => readFile(e.target.files?.[0])}
      />

      {/* Camera capture (mobile) */}
      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={(e) => readFile(e.target.files?.[0])}
      />

      <Dropdown align="end">
        <Dropdown.Toggle
          size="sm"
          variant="outline-secondary"
          className="tricho-imgpicker__toggle"
          disabled={isReading}
        >
          {isReading ? "Carregando..." : "Adicionar imagem"}
        </Dropdown.Toggle>

        <Dropdown.Menu className="tricho-imgpicker__menu">
          <Dropdown.Item onClick={() => uploadRef.current?.click()}>
            Upload (arquivo/galeria)
          </Dropdown.Item>
          <Dropdown.Item onClick={() => cameraRef.current?.click()}>
            Tirar foto (câmera)
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <AppButton
        size="sm"
        variant="secondary"
        isOutline
        onClick={() => uploadRef.current?.click()}
        name="Upload rápido"
        disabled={isReading}
      />
    </div>
  );
}